import { render, staticRenderFns } from "./ResolutionControlCustoms.vue?vue&type=template&id=f3c2ed36"
import script from "./ResolutionControlCustoms.vue?vue&type=script&lang=js"
export * from "./ResolutionControlCustoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports